<template>
	<div>
		<a href="/ContactUs#demo_form" class="trial_link" @click.prevent="goToDemoForm">
			<div class="button"><span style="font-weight: bold;">申请试用</span></div>
		</a>
	</div>
</template>

<script>
	// 表单锚点与让开固定页头所需的偏移量，与 main.js 中 scrollBehavior 的取值保持一致
	const FORM_ANCHOR = '#demo_form'
	const HEADER_OFFSET = 100

	export default {
		name: 'TrialButton',
		methods: {
			goToDemoForm() {
				// 已经在联系我们页时直接滚动，避免重复导航（路由不变则不会触发 scrollBehavior）
				if (this.$route.path === '/ContactUs') {
					const target = document.querySelector(FORM_ANCHOR)
					if (target) {
						const top = target.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET
						window.scrollTo({ top, behavior: 'smooth' })
					}
					return
				}
				this.$router.push({ path: '/ContactUs', hash: FORM_ANCHOR })
			}
		}
	};
</script>

<style scoped>
	.trial_link {
		text-decoration: none;
	}

	.button {
		position: relative;
		padding: 10px;
		padding-left: 20px;
		width: 70px;
		background: #fff100;
		color: #000;
		border-radius: 5px;
		overflow: hidden;
		cursor: pointer;
	}
</style>
